import { Grid } from 'jrgrid';
import { columns } from './utils';
import { pageApplicationUsers } from './api';
import Navbar from '../../../components/Navbar';
import React, { Fragment } from 'react';

export const ViewUsers = () => {
  return (
    <Fragment>
      <Navbar />
      <h3 className='ml-5 mt-2'>View Users</h3>
      <div className='ml-5 mr-5'>
        <Grid amount={20} columns={columns} defaultSortField='id' query={pageApplicationUsers} queryName='pageApplicationUsers' globalFilters={[]} />
      </div>
    </Fragment>
  );
};
